import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import * as constants from "../../../constants";
import environment from "../../../environments/environment";
import { RootState } from "../../../store/store";
import { axiosInterceptor } from "../services/authInterceptor";

interface AuthResult {
  code: string;
  realmId: string;
  state: string;
}

interface AuthMessage {
  code?: string;
  realmId?: string;
  state?: string;
  error?: string;
}

export const omiOAuth = () => {
  const [authResult, setAuthResult] = useState<AuthResult | null>(null);
  const [error, setError] = useState<string | null>(null);
  const popupRef = useRef<Window | null>(null);
  const checkIntervalRef = useRef<number | null>(null);

  const userDetails = useSelector((state: RootState) => state.auth);

  const contactInformationID = useSelector(
    (state: RootState) => state.participantDetails
  );
  const clientId: number = 1;
  const strVar: string | number | undefined =
    contactInformationID.participantId;
  const omiPartId: number = Number(strVar);
  const GET_CONNECTION_PARTICIPANT_CONFIGURED =
    environment.qboConnectionParticipantConfiguredURL;

  // Handle message from popup window
  useEffect(() => {
    // childOrigin is the child or the pop up window/callback url of Spring boot
    const childOrigin = "http://localhost:8080";
    const handleMessage = (event: MessageEvent<AuthMessage>) => {
      //  if (event.origin === window.location.origin) {
      if (event.origin === childOrigin) {
        const { code, realmId, state, error: authError } = event.data;

        if (code && realmId && state) {
          const result = { code, realmId, state };
          // display value of connectionSettingExists -true for success and false -fail
          getQboResponseById(omiPartId, clientId, state);
          setAuthResult(result);
          setError(null);
          if (checkIntervalRef.current) {
            clearInterval(checkIntervalRef.current);
            checkIntervalRef.current = null;
          }
          if (popupRef.current) {
            popupRef.current.close();
            popupRef.current = null;
          }
        } else if (authError) {
          console.error("Authentication error:", authError);
          setError(authError);
        }
      }
    };

    window.addEventListener("message", handleMessage as EventListener);
    return () => {
      window.removeEventListener("message", handleMessage as EventListener);
      if (checkIntervalRef.current) {
        clearInterval(checkIntervalRef.current);
        checkIntervalRef.current = null;
      }
    };
  }, []);

  // Function to check if connectionSettingExists is true or false (meaning user is authenticated or not)

  async function getQboResponseById(
    participantId: number,
    clientId: number,
    qboSessionId: string
  ) {
    setError(null); // Clear any previous errors
    try {
      const response = await axiosInterceptor.get(
        `${GET_CONNECTION_PARTICIPANT_CONFIGURED}${participantId}?clientId=${clientId}`
      );

      if (response && response.status === constants.STATUS_CODES.SUCCESS) {
        const qboDetails = response.data.data;
        toast.success(`User authentication completed successfullFy.`);
      }
    } catch (error: any) {
      setError(error.message);
      //  toast.error(error.response.data.message);
      if (error.response?.status === constants.STATUS_CODES.NOT_FOUND) {
        console.log("Need to call url to open the QBO Login form");
        console.log(omiPartId);
        console.log(clientId);
        console.log(qboSessionId);
      }
    } finally {
      //   setLoading(false); // Set loading to false after fetch is complete (success or error)
    }
  }

  return {
    // openPopup,
    authResult,
    error,
  };
};
